import { Component } from 'preact';
import { connect } from 'unistore/preact';
import CONSTANT from '../../utils/constants';
import BankAuthenticate from './bank-authenticate';
import SelectIfsc from '../select-ifsc';
import {
  accountInpRestricted,
  nameInpRestricted,
  validateAccountDetails,
  clearFieldError,
  selectIfscFromBank,
  validateIfscInput,
  validateMandateAuthDetails,
  updateInputValue
} from '../../controllers/bank-mandate';
import { locale } from '../../utils/i18n';
import { log, EVENT } from '../../common/logger';
import OverlayWrap from '../OverlayWrap';
import { getKey } from '../../utils/common';

class BankAccountDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountNumber: getKey(props, 'accountDetails.accountNumber', ''),
      accountHolderName: props.accountDetails.accountHolderName
        ? props.accountDetails.accountHolderName
        : '',
      ifsc: props.accountDetails.ifsc ? props.accountDetails.ifsc : '',
      mandateAuthMode: '',
      nameError: '',
      numberError: '',
      ifscError: '',
      authModeError: '',
      isNumberError: false,
      isNameError: false,
      isIfscError: false,
      isAuthModeError: false,
      showIfscList: false,
      ifscAPIData: ''
    };

    this.nameData = { blank: locale('bm.blank.name'), invalid: locale('bm.invalid.name') };
    this.numberData = { blank: locale('bm.blank.number'), invalid: locale('bm.invalid.number') };
    this.ifscData = { blank: locale('bm.blank.ifsc'), invalid: locale('bm.invalid.ifsc') };
    this.authModeData = { blank: locale('bm.blank.auth') };
    this.selectIfscData = {};
    this.accName = '';
  }

  closeSelectIfsc = (isData, data) => {
    if (isData) {
      this.setState({ ifsc: data.ifscCode, ifscAPIData: data.ifscCode });
    }
    this.setState({ showIfscList: false });
  };

  selectIfsc = () => {
    const apiData = {
      key: `${this.props.bank.channelCode}_IFSC_state_list`,
      request: { bankName: this.props.bank.channelName }
    };
    selectIfscFromBank(apiData.key, apiData.request, this.props.cache)
      .then(ifsc => {
        this.setState({ showIfscList: true, isIfscError: false });
        this.selectIfscData = ifsc.list;
      })
      .catch(error => {
        this.setState({ showIfscList: false, ifscError: error, isIfscError: true });
      });
  };

  showSelectIFSCError = error => {
    this.setState({ showIfscList: false, ifscError: error, isIfscError: true });
  };

  clearError = type => {
    this.setState(clearFieldError(type));
  };

  componentDidMount = () => {
    !this.state.accountNumber && this.accName && this.accName.focus();
  };

  onProceed = () => {
    if (this.props.bankDetailsEditable) {
      const data = validateAccountDetails(
        this.state.accountHolderName,
        this.state.accountNumber,
        this.state.ifsc,
        this.state.mandateAuthMode,
        this.nameData,
        this.numberData,
        this.ifscData,
        this.authModeData
      );
      if (data.stateData) {
        this.setState(data.stateData);
        if (data.submit) {
          const { accountNumber, accountHolderName, ifsc, mandateAuthMode } = this.state;
          const req = { ifscCode: ifsc };

          validateIfscInput(req, this.state.ifscAPIData, this.props.cache)
            .then(res => {
              res.ifscCode &&
                this.props.onProceedSubmit(accountNumber, accountHolderName, ifsc, mandateAuthMode);
            })
            .catch(res => {
              this.setState({ ifscError: res, isIfscError: true });
            });
        } else {
          log({
            eventType: 'BM_EVENT_CLIENT_VALIDATION'
          });
        }
      }
    } else {
      const data = validateMandateAuthDetails(this.state.mandateAuthMode, this.authModeData);
      if (data) {
        this.setState(data.stateData);
        if (data.submit) {
          const { accountNumber, accountHolderName, ifsc } = this.props.accountDetails;
          const mandateAuthMode = this.state.mandateAuthMode;
          this.props.onProceedSubmit(accountNumber, accountHolderName, ifsc, mandateAuthMode);
        } else {
          log({
            eventType: 'BM_EVENT_CLIENT_VALIDATION'
          });
        }
      }
    }
  };

  checkAccountNumber = e => {
    this.clearError('number');
    accountInpRestricted(e);
  };

  setAccountNumber = e => {
    if (e && e.target) {
      const stateData = updateInputValue(e, this.state.accountNumber, 'accountNumber');
      this.setState(stateData);
    }
  };

  checkAccountName = e => {
    this.clearError('name');
    nameInpRestricted(e);
  };

  setAccountName = e => {
    if (e && e.target) {
      const stateData = updateInputValue(e, this.state.accountHolderName, 'accountHolderName');
      this.setState(stateData);
    }
  };

  checkAccountIfsc = e => {
    accountInpRestricted(e);
  };

  setAccountIfsc = e => {
    this.clearError('ifsc');
    if (e && e.target) {
      const stateData = updateInputValue(e, this.state.ifsc, 'ifsc');
      this.setState(stateData);
    }
  };

  selectAuthMode = mode => {
    this.setState({ mandateAuthMode: mode });
    this.clearError('authMode');
    log({ eventType: EVENT.INPUT_ELE_CLICKED, paymode: CONSTANT.BM, elementName: mode });
  };

  render(
    { bank, changeBank, authenticateModes, bankDetailsEditable },
    {
      accountNumber,
      accountHolderName,
      ifsc,
      mandateAuthMode,
      nameError,
      numberError,
      ifscError,
      showIfscList,
      authModeError,
      isNameError,
      isNumberError,
      isIfscError
    }
  ) {
    return (
      <div className="ptm-account-details">
        <div className="ptm-selected-bank ptm-w100-ib">
          <div className="ptm-left">
            <img className="ptm-bank-logo-pic ptm-left" src={bank.iconUrl} alt="" />
            <span className="ptm-left ptm-bank-logo-name">{bank.channelName}</span>
          </div>
          {bankDetailsEditable && (
            <div className="ptm-changebank ptm-primary ptm-left" onClick={changeBank}>
              {locale('bm.change.bank')}
            </div>
          )}
        </div>
        <div className="ptm-w100-ib">
          <div className="ptm-inputfield-wrap">
            <input
              type="text"
              className="ptm-inputfield"
              placeholder={locale('bm.enter.name')}
              onKeyDown={this.checkAccountName}
              onClick={() =>
                log({
                  eventType: EVENT.INPUT_ELE_CLICKED,
                  paymode: CONSTANT.BM,
                  elementName: 'account_Holder_Name'
                })
              }
              onInput={this.setAccountName}
              value={accountHolderName}
              maxLength={CONSTANT.ACCOUNT_NAME_MAX_LENGTH}
              autocomplete="off"
              ref={fl => {
                this.accName = fl;
              }}
              readOnly={!bankDetailsEditable}
              disabled={!bankDetailsEditable}
            />
            {isNameError && <p className="ptm-small-txt ptm-msg-red ptm-pos-a">{nameError}</p>}
          </div>
          <div className="ptm-inputfield-wrap">
            <input
              type="text"
              className="ptm-inputfield"
              placeholder={locale('bm.enter.number')}
              onKeyDown={this.checkAccountNumber}
              onClick={() =>
                log({
                  eventType: EVENT.INPUT_ELE_CLICKED,
                  paymode: CONSTANT.BM,
                  elementName: 'account_Number'
                })
              }
              onInput={this.setAccountNumber}
              value={accountNumber}
              maxLength={CONSTANT.ACCOUNT_NUMBER_MAX_LENGTH}
              autocomplete="off"
              readOnly={!bankDetailsEditable}
              disabled={!bankDetailsEditable}
            />
            {isNumberError && <p className="ptm-small-txt ptm-msg-red ptm-pos-a">{numberError}</p>}
          </div>
          <div className="ptm-inputfield-wrap ptm-pos-r">
            <input
              type="text"
              className="ptm-inputfield  upper"
              placeholder={locale('bm.enter.ifsc')}
              onKeyDown={this.checkAccountIfsc}
              onClick={() =>
                log({
                  eventType: EVENT.INPUT_ELE_CLICKED,
                  paymode: CONSTANT.BM,
                  elementName: 'account_Ifsc'
                })
              }
              onInput={this.setAccountIfsc}
              value={ifsc}
              maxLength={CONSTANT.ACCOUNT_IFSC_LENGTH}
              autocomplete="off"
              readOnly={!bankDetailsEditable}
              disabled={!bankDetailsEditable}
            />
            {isIfscError && <p className="ptm-small-txt ptm-msg-red ptm-pos-r">{ifscError}</p>}
            {bankDetailsEditable && (
              <div className="ptm-primary ptm-ifsc ptm-pos-a " onClick={this.selectIfsc}>
                {locale('bm.find.ifsc')}
              </div>
            )}
          </div>
        </div>
        <BankAuthenticate
          authenticateModes={authenticateModes}
          selectMode={this.selectAuthMode}
          authModeError={authModeError}
          populateMode={mandateAuthMode}
        />

        {showIfscList && (
          <div className="ptm-emi-overlay">
            <OverlayWrap>
              <SelectIfsc
                bank={bank}
                ifscStateData={this.selectIfscData}
                closeSelectIfsc={this.closeSelectIfsc}
                showSelectIFSCError={this.showSelectIFSCError}
              />
            </OverlayWrap>
          </div>
        )}
      </div>
    );
  }
}

export default connect(
  'cache',
  null
)(BankAccountDetails);



// WEBPACK FOOTER //
// ./components/bank-mandate/bank-account-details.js